import PropTypes from "prop-types";
import React, { useEffect, useState, useContext, useRef, useLayoutEffect, useCallback } from "react";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import HeaderTop from "../../components/header/HeaderTop";
import { Link } from 'react-router-dom';
import LogoAndStoreName from "../../components/header/LogoChange";
import { AuthContext } from "../../common/Auth";
import LoginIconGroup from "../../components/header/LoginIconGroup";
import { useHeaderState } from "../../layouts/state/useHeaderState";
const HeaderOne = ({
  layout,
  top,
  borderStyle,
  headerPaddingClass,
  headerPositionClass,
  headerBgClass,
  relativePosition,
  isPublic
}) => {
  const { themeSettingsData, user, settingData, enableLandingPage } = useContext(AuthContext)
  const [menuStyleData, setmenuStyleData] = useState([]);
  const [headerTopMenu, setHeaderTopMenu] = useState([]);
  const [themeName, setThemeName] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState("");

  const {
    headerRef,
    headerWrapperRef,
    contentMargin,
    minHeaderHeight
  } = useHeaderState();

  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "headerMenu") {
          if (i.values[0].menuSettings) {
            setmenuStyleData(i.values[0].menuSettings);
          }
        }
        if (i.settingsName === "headerTopMenu") {
          setHeaderTopMenu(i.values[0]);
        }
        if (i.settingsName === "theme") {
          setThemeName(i.values[0].themeName);
        }
      })
    }
  }, [themeSettingsData]);

  useEffect(() => {
    if (menuStyleData?.menuBackgroundcolor) {
      setBackgroundColor(menuStyleData.menuBackgroundcolor);
    } else {
      setBackgroundColor(themeName === "dark" ? "#1b1b1b" : "#fff");
    }
  }, [menuStyleData, themeName])


  let menuULStyle = {}
  if (menuStyleData && menuStyleData != undefined && Object.keys(menuStyleData).length > 0) {
    menuULStyle = {
      backgroundColor: backgroundColor,
      backgroundImage: `url(${menuStyleData.menuBackgroundImage})`,
      borderBottom: menuStyleData.menuBottomlineColor != "" ? `${menuStyleData.menuBottomlineThickness ? menuStyleData.menuBottomlineThickness : 1}px solid ${menuStyleData.menuBottomlineColor}` : "",
      borderTop: menuStyleData.menuToplineColor != "" ? `${menuStyleData.menuToplineThickness ? menuStyleData.menuToplineThickness : 1}px solid ${menuStyleData.menuToplineColor}` : ""
    }
  }
  return (
    <div id="header" ref={headerWrapperRef} style={{marginBottom: contentMargin}}>
      <header
        className={`header-area ${headerBgClass ? headerBgClass : ""} ${!menuStyleData?.menuBackgroundcolor ? (headerPositionClass ? headerPositionClass : "") : ""
          }`}
        style={{ ...(relativePosition && { position: 'relative' }) }}
      >
        {(user || isPublic) && 
        <div
        style={{background: headerTopMenu.bgColor ? headerTopMenu.bgColor : "#fff"}}
          className={`${headerPaddingClass ? headerPaddingClass : ""} 
          ${top === "visible" ? (headerTopMenu?.isEnabledNavigatinMobile ? `d-lg-block` : `d-none d-lg-block`) : "d-none"} header-top-area 
          ${borderStyle === "fluid-border" ? "border-none" : ""}`}
        >
          <div className={layout === "container-fluid" ? layout : "container"}>
            {/* header top */}
            <HeaderTop borderStyle={borderStyle} />
          </div>
        </div>
        }
        <div style={minHeaderHeight ? {maxHeight: minHeaderHeight} : {}}>
          <div
            style={menuULStyle}
            ref={headerRef}
            className={`antera-header-menu-container ${headerPaddingClass ? headerPaddingClass : ""
              } sticky-bar header-res-padding ${contentMargin ? "stick" : ""
              }`}
          >
            <div className={layout === "container-fluid" ? layout : "container"}  >

              <div className="inner-header-container">
              {/* {(user || isPublic) && */}
                <div className="header-logo-container" >
                  {/* header logo */}
                  <Link to={process.env.PUBLIC_URL + "/"}>
                    <LogoAndStoreName menuStyleData={menuStyleData} isHeader={true} />
                  </Link>
                </div>
                {/* } */}
                <div className="d-none d-lg-block header-menu-items" style={{ position: "unset" }}>
                  {/* Nav menu */}
                {(user || isPublic) && <NavMenu divHeader={headerWrapperRef} /> }
                  
                </div>
                {(user || isPublic) &&
                  <div className="antera-header-icon-group header-account-info">
                    {/* Icon group */}
                    <IconGroup />
                  </div>
                }
                {(!isPublic && enableLandingPage && !user) &&
                  <LoginIconGroup />
                }
              </div>
            </div>
            {/* mobile menu */}
            <MobileMenu />
          </div>
        </div>
      </header>
    </div>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string
};

export default HeaderOne;
